<template>
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />

        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        (!isUpdate && permissao.create) ||
                        (isUpdate && permissao.update && !integracao)
                    "
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-2">
                    <v-input
                        :id="generateId(1)"
                        ref="idErpInput"
                        v-model="prazoPagamento.idprazopagtoerp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        uppercase
                        :disabled="integracao"
                        tooltipLabel="cod-ref"
                        required
                        :invalid="!prazoPagamento.idprazopagtoerp"
                    />
                </div>
                <div class="column is-7">
                    <v-input
                        :id="generateId(2)"
                        ref="nomeInput"
                        v-model="prazoPagamento.descricao"
                        placeholder="placeholder-preencha"
                        :maxlength="50"
                        title="descricao"
                        msg="msg-campo-obrigatorio"
                        :invalid="!prazoPagamento.descricao"
                        uppercase
                        :disabled="integracao"
                        required
                        tooltipLabel="info-descricao-prazo-pagamento"
                    />
                </div>

                <div class="column is-3">
                    <vss-select
                        :id="generateId(3)"
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacoes"
                        v-model="situacao"
                        class="no-clear"
                        :mlLabels="true"
                        :disabled="prazoPagamento.id == null || integracao"
                        title="situacao"
                        tooltipLabel="info-situacao-prazo-pagamento"
                        tooltipPosition="is-left"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PrazoPagtoService from '@/services/vendas/prazopagto/PrazoPagtoService';
import PrazoPagamentoValidation from '@/services/validations/vendas/prazopagto/PrazoPagamentoValidation';
import Message from '@/models/Message';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    components: {
        HideInfo,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('PRAZOPAGTO'),
            service: new PrazoPagtoService(this.$http, this.$router),
            validation: new PrazoPagamentoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            prazoPagamento: {
                id: null,
                idprazopagtoerp: null,
                descricao: null,
                situacao: null,
            },
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },

            permissao: false,
            cantEdit: false,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
        };
    },
    computed: {
        ...mapState(['hide']),
    },
    watch: {
        prazoPagamento: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit('isChanged', true);
                }
            },
        },
    },
    created() {
        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 500);

        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-prazo-pagamento');
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'prazo-pagamento' },
            });
        } else {
            if (this.isUpdate) {
                this.cantEdit = !this.permissao.update;
                this.carregarDados();
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-geral-' + numberId;
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.$route.params.id)
                .then((value) => {
                    this.prazoPagamento = value.content;
                    this.situacao = this.situacoes[this.prazoPagamento.situacao];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },

        save() {
            this.isLoading = true;

            if (this.validation.validate(this.prazoPagamento, this.$refs)) {
                let prazoTemp = Object.assign({}, this.prazoPagamento);
                prazoTemp = this.mapTosave(prazoTemp);
                prazoTemp.situacao = this.situacao.id;

                this.isSaving = true;
                this.service
                    .save(prazoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-prazo-pagamento';
                            if (this.prazoPagamento.idprazopagto != null) {
                                msg = 'msg-edit-prazo-pagamento';
                            }
                            this.msgs.push(new Message('success', msg, true));

                            if (this.$route.query.tela) {
                                this.redirectToPage();
                            } else {
                                this.redirectToList(value.content.id);
                            }
                        } else {
                            if (this.$te(value.message)) {
                                if (value.message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(value.message, { n: prazoTemp.idprazopagtoerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', value.message, true));
                                }
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(message, { n: prazoTemp.idprazopagtoerp }),
                                        true,
                                        false
                                    )
                                );
                            } else if (this.$te(message)) {
                                this.msgs.push(new Message('alert', message, true));
                            }

                            return;
                        }

                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    })
                    .finally(() => {
                        this.$emit('isChanged', false);
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        redirectToList(id) {
            setTimeout(() => {
                this.$router.push({
                    name: 'ven-prazo-pagamento-edit',
                    params: { id: +id },
                });
            }, 1000);
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            if (this.$route.query.tela == 'ven-prazo-pagamento') {
                tempTela = 'ven-prazo-pagamento-edit';
                tempAba = 'dados-cadastrais';
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query['id'] },
                    query: { abaSelecionada: tempAba },
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
